// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Logo_wrapper__2EteJ","image":"Logo_image__1wGer"};